import { createSlice } from "@reduxjs/toolkit";
import { getFoProcurementReport } from "./actions/foProcurementReport";

const initialState = {
  foProcurementReport: null,
  total: 0,
  loading: false,
  pageState: { page: 1, pageSize: 50 },
};

export const foProcurementReportSlice = createSlice({
  name: "foProcurementReport",
  initialState,
  reducers: {
    setFoProcurementPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.pageState = {
          ...state.pageState,
          page,
        };
      }
      if (pageSize) {
        state.pageState = {
          ...state.pageState,
          pageSize,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFoProcurementReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFoProcurementReport.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.foProcurementReport = data;
        state.total = count;
      })
      .addCase(getFoProcurementReport.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFoProcurementPage } = foProcurementReportSlice.actions;

export default foProcurementReportSlice.reducer;
